// extracted by mini-css-extract-plugin
module.exports = {"exchangeCardRoot":"RyDuRU7c","details":"mm7h1lxP","title":"cAQgYnPn","subtitle":"TH2VCAQh","country":"WSFQinBs"};